/**
 * Create a function to replace content in a regex
 */
function replace(regex: RegExp, map: { [name: string]: RegExp | string }, opt = '') {
    let { source } = regex;

    Object.keys(map).forEach((name) => {
        const val = map[name];
        let valSource = typeof val === 'string' ? val : val.source;
        valSource = valSource.replace(/(^|[^[])\^/g, '$1');
        source = source.replace(name, valSource);
    });

    return new RegExp(source, opt);
}

// quote related
const singleQuoted = /'(?:[^'\\]|\\.)*'/;
const doubleQuoted = /"(?:[^"\\]|\\.)*"/;
const quoted = replace(/singleQuoted|doubleQuoted/, { singleQuoted, doubleQuoted });

// basic types
const number = /-?\d+\.?\d*|\.?\d+/;
const bool = /true|false/;

// property access
const identifier = /@?[\w-/]+/;
const literal = replace(/(?:quoted|bool|number)/, { quoted, bool, number });

// Match inner of the tag to split the name and the props
export const tagLine = replace(/^\s*(identifier)\s*(.*)\s*$/, { identifier });

// Types
export const numberLine = replace(/^number$/, { number });
export const boolLine = replace(/^bool$/i, { bool });
export const quotedLine = replace(/^quoted$/, { quoted });

// Assignment of a variable message="Hello"
const assignment = replace(/(identifier)\s*=\s*(literal)/, { identifier, literal });

// Argument or kwargs
const delimiter = /(?:\s*|^)/;
export const prop = replace(/(?:delimiter)(?:(assignment|literal))/, {
    literal,
    delimiter,
    assignment,
});
